import React, { useContext, useEffect, useState } from 'react';
import { Button, TextField, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './LoginStyle';
import { AppContext } from '../../../App';

type LoginTwoPasswordProps = {
  oneteimePassword: string;
  onetimePasswordValidityTime: number;
  changeoneteimePassword: (userName: string) => void;
  ontimeLoginAction: () => void;
  backAction: () => void;
};


const LoginTwoPasswordMode: React.FC<LoginTwoPasswordProps> = (props) => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <div className={classes.entryContainer}>
      <div style={{ height: '50px' }}></div>
      <div style={{ height: '70px' }}>
        <div className={classes.messageLabel}>{t('LoginTwoPasswordMode.2段階認証のパスワードをメールアドレスに', '2段階認証のパスワードをメールアドレスに')} </div>
        <div className={classes.messageLabel}>{t(`LoginTwoPasswordMode.送信しました（有効期間）`, `送信しました（有効期間：`) + `${props.onetimePasswordValidityTime}` + t('LoginTwoPasswordMode.分間', '分間）')} </div>
      </div>


      <div style={{ height: '10px' }}></div>

      <div className={classes.twoPasswordLabel}>{t('LoginTwoPasswordMode.2段階パスワード', '2段階パスワード')}</div>
      <div className={classes.entryRow}>
        <TextField
          variant="outlined"
          size="small"
          type="password"
          className={classes.entry}
          value={props.oneteimePassword}
          onChange={(e) => props.changeoneteimePassword(e.target.value)}
          onKeyPress={(e) => {
            if (e.key == 'Enter') {
              e.preventDefault();
              props.ontimeLoginAction();
            }
          }}
          inputProps={{
            maxLength: 40,
          }}
        />
      </div>
      <div>
        <>
          <Button className={classes.twoPasswordButton} variant="outlined" onClick={(e) => props.ontimeLoginAction()}>
            {t('LoginTwoPasswordMode.ログイン', 'ログイン')}
          </Button>
          <Button className={classes.twoPasswordButton} variant="outlined" onClick={(e) => props.backAction()}>
            {t('LoginTwoPasswordMode.戻る', '戻る')}
          </Button>
        </>
      </div>
    </div>

  );
};
export default LoginTwoPasswordMode;